import { render, staticRenderFns } from "./FinishReviewModal.vue?vue&type=template&id=51cb0de2&scoped=true"
import script from "./FinishReviewModal.vue?vue&type=script&lang=ts"
export * from "./FinishReviewModal.vue?vue&type=script&lang=ts"
import style0 from "./FinishReviewModal.vue?vue&type=style&index=0&id=51cb0de2&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cb0de2",
  null
  
)

export default component.exports